import React from 'react';
import { LayersIcon, ZapIcon, SmartphoneIcon, TrendingUpIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { PriceBlock } from './PriceBlock';
import { HERO_IMAGE_URL } from '../utils/headMeta';
import { PRODUCT_FACTS } from './salesData';
const HERO_IMG = HERO_IMAGE_URL;
/** Intrinsic size of the mockup — used to reserve layout space (avoids CLS). */
const HERO_IMG_WIDTH = 1024;
const HERO_IMG_HEIGHT = 1024;
const badges = [{
  icon: LayersIcon,
  label: 'Implementación en 5 tomos'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: TrendingUpIcon,
  label: 'Enfocado en rentabilidad'
}, {
  icon: SmartphoneIcon,
  label: '100% digital'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-sand" data-id="element-202" data-mp="nb6k1klpt7kg">
      <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-sage-soft blur-3xl" aria-hidden data-id="element-203" data-mp="3d1ikzavvpeny" />
      <div className="absolute -bottom-32 -left-24 h-80 w-80 rounded-full bg-gold-soft/70 blur-3xl" aria-hidden data-id="element-204" data-mp="382p5xe0y1flo" />

      <div className="relative mx-auto max-w-3xl px-5 py-6 text-center sm:py-12" data-id="element-205" data-mp="3j7zhzqi0g6kd">
        <div className="animate-hero-copy" data-id="element-206" data-mp="3o7c1c19oavi7">
          <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep sm:text-[0.66rem]" data-id="element-207" data-mp="3o6aru18b2h2l">
            Para odontólogos con consultorio propio
          </p>
          <h1 className="mx-auto mt-2.5 max-w-[20ch] font-display text-[1.7rem] font-bold uppercase leading-[1.1] text-charcoal sm:max-w-[26ch] sm:text-[2.5rem]" data-id="element-208" data-mp="3e8ehvcr3ts62">
            Hacé que tu consultorio te deje más dinero
            <span className="mt-1 block text-gold-deep" data-id="element-209" data-mp="35aasu6gwud9i">sin atender cada vez más</span>
          </h1>
          <p className="mx-auto mt-3 max-w-[36ch] font-sans text-[0.88rem] leading-relaxed text-charcoal/75 sm:max-w-2xl sm:text-[0.95rem]" data-id="element-210" data-mp="2qlelycqlb6ah">
            Detectá dónde se escapa la rentabilidad de tu consultorio, convertí mejor consultas y
            presupuestos, recuperá oportunidades perdidas y hacé rendir más{' '}
            <strong className="font-semibold text-charcoal" data-id="element-211" data-mp="2lmla0oqybncf">cada hora de trabajo</strong>.
          </p>
        </div>

        <img src={HERO_IMG} alt="Método Consultorio Rentable: los cinco tomos del sistema junto a una tablet con los indicadores del consultorio" width={HERO_IMG_WIDTH} height={HERO_IMG_HEIGHT} fetchPriority="high" decoding="async" sizes="(max-width: 640px) 60vw, 380px" style={{
        aspectRatio: `${HERO_IMG_WIDTH} / ${HERO_IMG_HEIGHT}`
      }} className="animate-hero-media mx-auto mt-3 block h-auto w-[62%] max-w-[250px] rounded-xl object-contain sm:mt-5 sm:w-[70%] sm:max-w-[380px]" data-id="element-212" data-mp="nbba6qtxtx1l" />

        <p className="mt-3 font-display text-[1.05rem] font-bold uppercase leading-tight text-charcoal sm:text-[1.35rem]" data-id="element-213" data-mp="114ssy9esv5qk">
          Método Consultorio Rentable
        </p>
        <p className="mt-1 font-sans text-[0.85rem] font-medium text-charcoal/75 sm:text-[0.95rem]" data-id="element-214" data-mp="3luiaiu6w15my">
          Sistema práctico de implementación en 5 tomos
        </p>
        <p className="font-sans text-[0.85rem] font-semibold text-gold-deep sm:text-[0.95rem]" data-id="element-215" data-mp="1xa429a5swchi">
          + 5 recursos extra de regalo
        </p>

        <PriceBlock className="mt-3" data-id="element-216" data-mp="218toztcqb6dt" />

        <div className="mt-3.5 flex justify-center" data-id="element-217" data-mp="269hegalb7f5x">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-218" data-mp="268obzltdvbtl" />
        </div>

        <p className="mt-2.5 font-sans text-[0.72rem] text-charcoal/60" data-id="element-219" data-mp="2b1hiae4i2s7s">
          Acceso inmediato · 100% digital · Aplicalo en tu propio consultorio
        </p>
        <p className="mt-1 font-sans text-[0.7rem] text-charcoal/50" data-id="element-220" data-mp="2kynd9xg8j3da">
          🔒 Pago seguro · Mercado Pago · Tarjetas de crédito
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-1.5" data-id="element-221" data-mp="2p10dk6c7q92o">
          {badges.map(b => <span key={b.label} className="inline-flex items-center gap-1.5 rounded-full border border-stone bg-ivory px-2.5 py-1.5 font-sans text-[0.66rem] font-medium text-charcoal/80" data-id="element-222" data-mp="2txhek14ighx6">
              <b.icon className="h-3.5 w-3.5 text-gold-deep" aria-hidden data-id="element-223" data-mp="4b45noxezwhc" />
              {b.label}
            </span>)}
        </div>
      </div>

      <div className="relative border-t border-stone bg-ivory/70" data-id="element-224" data-mp="3vh5ju6cof677">
        <div className="mx-auto flex max-w-4xl flex-wrap items-center justify-center gap-x-5 gap-y-1.5 px-5 py-3 text-center font-sans text-[0.74rem] text-charcoal/70" data-id="element-225" data-mp="e9tr1roirz2c">
          {PRODUCT_FACTS.map((fact, i) => <React.Fragment key={fact} data-id="element-226" data-mp="3hr25e1k1ggsb" data-mpi={i}>
              {i > 0 && <span className="hidden h-3.5 w-px bg-stone-deep sm:block" aria-hidden data-id="element-227" data-mp="3cr7gu4nqk3af" />}
              <span data-id="element-228" data-mp="3cpctykswm13p">{fact}</span>
            </React.Fragment>)}
        </div>
      </div>
    </section>;
}